(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[65],{

/***/ 57419:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/signin",
      function () {
        return __webpack_require__(75289);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SEO_SEO; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(48512);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/head.js
var head = __webpack_require__(55566);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/router.js
var router = __webpack_require__(30590);
;// CONCATENATED MODULE: ./src/components/shared/SEO/SEO.tsx
/* provided dependency */ var process = __webpack_require__(87943);



const TERMS = {
    title: "workplay",
    baseURL: process.env.VERCEL_URL
};
const SEO = (param)=>{
    let { title , desc , type , imageUrl  } = param;
    const { asPath  } = (0,router.useRouter)();
    const tabInfo = {
        title: title ? "".concat(title, " ⁄ ").concat(TERMS.title) : TERMS.title,
        desc: desc ? desc : TERMS.title
    };
    const seoImage = imageUrl || "";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: tabInfo.title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:title",
                content: tabInfo.title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:description",
                content: tabInfo.desc
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "description",
                content: tabInfo.desc
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "canonical",
                href: "".concat(TERMS.baseURL).concat(asPath)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:url",
                content: "".concat(TERMS.baseURL).concat(asPath)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:image",
                content: seoImage
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:type",
                content: type || "website"
            })
        ]
    });
};
/* harmony default export */ var SEO_SEO = (SEO);

;// CONCATENATED MODULE: ./src/components/shared/SEO/index.ts



/***/ }),

/***/ 75289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ SignIn; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48512);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11321);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83658);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10461);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26801);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69224);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80883);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96756);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25096);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30590);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86286);
/* harmony import */ var _components_shared_Logo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73566);
/* harmony import */ var _components_shared_SEO__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10923);







var __N_SSP = true;
function SignIn(param) {
    let { providers , csrfToken  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { callbackUrl  } = router.query;
    // Filter out credentials provider for production
    const filteredProviders = providers ? Object.values(providers).filter((provider)=>provider.id !== "credentials") : [];
    // Sort providers to put Google first
    const sortedProviders = filteredProviders.sort((a, b)=>{
        if (a.id === "google") return -1;
        if (b.id === "google") return 1;
        return 0;
    });
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_shared_SEO__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                title: "Sign In"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Center */ .M, {
                minH: "100vh",
                bg: "gray.50",
                _dark: {
                    bg: "gray.900"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W, {
                    maxW: "md",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .VStack */ .g, {
                        spacing: 8,
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_shared_Logo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .VStack */ .g, {
                                spacing: 3,
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Heading */ .X, {
                                        size: "xl",
                                        children: "Welcome to workplay"
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                                        color: "gray.600",
                                        _dark: {
                                            color: "gray.400"
                                        },
                                        children: "Sign in to track your office game performance"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Stack */ .K, {
                                spacing: 4,
                                w: "full",
                                children: sortedProviders.map((provider)=>/*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Button */ .z, {
                                        onClick: ()=>(0,next_auth_react__WEBPACK_IMPORTED_MODULE_0__.signIn)(provider.id, {
                                                callbackUrl: callbackUrl || "/"
                                            }),
                                        size: "lg",
                                        colorScheme: provider.id === "google" ? "blue" : "gray",
                                        leftIcon: provider.id === "google" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_icons_fa__WEBPACK_IMPORTED_MODULE_12__/* .FaGoogle */ .ldW, {}) : undefined,
                                        w: "full",
                                        children: [
                                            "Sign in with ",
                                            provider.name
                                        ]
                                    }, provider.name))
                            }),
                             false && /*#__PURE__*/ 0
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 11321:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ Center; }
/* harmony export */ });
/* unused harmony export AbsoluteCenter */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52676);
/* harmony import */ var _system_factory_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6793);
/* harmony import */ var _system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6579);
'use client';




const Center = (0,_system_factory_mjs__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m)("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});
Center.displayName = "Center";
const centerStyles = {
  horizontal: {
    insetStart: "50%",
    transform: "translateX(-50%)"
  },
  vertical: {
    top: "50%",
    transform: "translateY(-50%)"
  },
  both: {
    insetStart: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  }
};
const AbsoluteCenter = (0,_system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(
  function AbsoluteCenter2(props, ref) {
    const { axis = "both", ...rest } = props;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      _system_factory_mjs__WEBPACK_IMPORTED_MODULE_1__/* .chakra.div */ .m.div,
      {
        ref,
        __css: centerStyles[axis],
        ...rest,
        position: "absolute"
      }
    );
  }
);




/***/ }),

/***/ 26801:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Heading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52676);
/* harmony import */ var _chakra_ui_styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41902);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95558);
/* harmony import */ var _system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6579);
/* harmony import */ var _system_use_style_config_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54678);
/* harmony import */ var _system_factory_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6793);
'use client';







const Heading = (0,_system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(
  function Heading2(props, ref) {
    const styles = (0,_system_use_style_config_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useStyleConfig */ .m)("Heading", props);
    const { className, ...rest } = (0,_chakra_ui_styled_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .L)(props);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      _system_factory_mjs__WEBPACK_IMPORTED_MODULE_4__/* .chakra.h2 */ .m.h2,
      {
        ref,
        className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__.cx)("chakra-heading", props.className),
        ...rest,
        __css: styles
      }
    );
  }
);
Heading.displayName = "Heading";




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [989,774,888,179], function() { return __webpack_exec__(57419); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);